import script from "./ContactInformationPrompt.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactInformationPrompt.vue?vue&type=script&setup=true&lang=js"

import "./ContactInformationPrompt.vue?vue&type=style&index=0&id=1000b84a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1000b84a"]])

export default __exports__